import {
  messageAreaMaxCount,
  messageEditorMaxCount,
  messageMinCount,
} from '../constants/common';

export const searchSelector = (state) => state.questionsStore.searchVal;
export const filterVisibleSelector = (state) =>
  state.questionsStore.filterVisible;
export const selectedQuestionSelector = (state) =>
  state.questionsStore.selectedQuestion;
export const periodSelector = (state) => state.questionsStore.period;
export const typesSelector = (state) => state.questionsStore.types;
export const statesSelector = (state) => state.questionsStore.states;
export const companiesSelector = (state) => state.questionsStore.companies;
export const streetsSelector = (state) => state.questionsStore.streets;
export const housesSelector = (state) => state.questionsStore.houses;
export const addressesSelector = (state) => state.questionsStore.addresses;
export const isHtmlSelector = (state) => state.questionsStore.isHtml;
export const localFilesSelector = (state) => state.questionsStore.localFiles;
export const editorStateSelector = (state) => state.questionsStore.editorState;
export const editorLinkModalDataSelector = (state) =>
  state.questionsStore.editorLinkModalData;
export const editorPhoneModalDataSelector = (state) =>
  state.questionsStore.editorPhoneModalData;
export const messageAreaStateSelector = (state) =>
  state.questionsStore.messageAreaState;
export const answerStatusSelector = (state) =>
  state.questionsStore.answerStatus;
export const closeQuestionRejectedSelector = (state) =>
  state.questionsStore.closeQuestionRejected;
export const sortDataSelector = (state) => state.questionsStore.sortData;
export const importantQuestionsFirstSelector = (state) =>
  state.questionsStore.importantQuestionsFirst;
export const questionReactionSelector = (state) =>
  state.questionsStore.reaction;
export const questionsSaveDataSelector = (state) => {
  const {
    period,
    types,
    states,
    companies,
    streets,
    houses,
    addresses,
    answerStatus,
    reaction,
    closeQuestionRejected,
    searchVal,
    selectedQuestion,
    sortData,
    importantQuestionsFirst,
    notificationQuestion,
  } = state.questionsStore;

  return {
    period,
    types,
    states,
    companies,
    streets,
    houses,
    addresses,
    answerStatus,
    reaction,
    closeQuestionRejected,
    searchVal,
    selectedQuestion,
    sortData,
    importantQuestionsFirst,
    notificationQuestion,
  };
};
export const questionsServerFiltersSelector = (state) => {
  const { period, types, states, companies, streets, houses, addresses } =
    state.questionsStore;

  return {
    period,
    types,
    states,
    companies,
    streets,
    houses,
    addresses,
  };
};

export const notificationQuestionSelector = (state) =>
  state.questionsStore.notificationQuestion;

const isEditorDisabled = (editor) => {
  const length = editor.getCurrentContent().getPlainText().length;
  return length < messageMinCount || length > messageEditorMaxCount;
};
const isTextAreaDisabled = (text) => {
  const length = text?.length || 0;
  return length < messageMinCount || length > messageAreaMaxCount;
};
export const isSubmitMsgDisabledSelector = (state) => {
  const { isHtml, editorState, messageAreaState } = state.questionsStore;

  return isHtml
    ? isEditorDisabled(editorState)
    : isTextAreaDisabled(messageAreaState);
};
